var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SelectTagsModal',{ref:`selectTagsModal${_vm.windowId}`,attrs:{"treeNode":_vm.treeNode,"node":_vm.node,"windowId":_vm.windowId,"resource":_vm.selectedResource},on:{"select":_vm.select}}),_c('b-overlay',{attrs:{"show":_vm.isLoading,"bg-color":'transparent',"no-wrap":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }